/* eslint-disable */
export default {
  order: 4,
  header: [],
  content: [
    {
      category: '2.4 发布记录 (2023/02/27)',
      description: '查看 EnOS 版本信息。',
      url: '',
      isVersionInfo: true,
      item: [
        {
          name: 'EnOS Cloud 2.4 Cumulative Updates',
          description: 'Cumulative Update （CU）是每个季度内新功能、优化与错误修复的集合。',
          image: '',
          list: [
            {
              name: '2.4 CU 3',
              url: '/docs/enos/zh_CN/2.4.0/releasenotes/cu3.html'
            },
            {
              name: '2.4 CU 2',
              url: '/docs/enos/zh_CN/2.4.0/releasenotes/cu2.html'
            },
            {
              name: '2.4 CU 1',
              url: '/docs/enos/zh_CN/2.4.0/releasenotes/cu1.html'
            }
          ]
        },
        {
          name: 'EnOS Cloud 2.4',
          description: '',
          image: 'assets/images/EnOS_Cloud_RN.png',
          list: [
            {
              name: '新增功能与功能改进',
              url: '/docs/enos/zh_CN/2.4.0/releasenotes/new_feature.html'
            },
            {
              name: '行为变更',
              url: '/docs/enos/zh_CN/2.4.0/releasenotes/enhancement.html'
            },
            {
              name: '弃用/移除功能',
              url: '/docs/enos/zh_CN/2.4.0/releasenotes/deprecated.html'
            },
            {
              name: '已知问题',
              url: '/docs/enos/zh_CN/2.4.0/releasenotes/knownissue.html'
            }
          ]
        },
        {
          name: 'EnOS Edge 2.4',
          description: '',
          image: 'assets/images/Edge_RN.png',
          list: [
            {
              name: '新增功能与功能改进',
              url: '/docs/enos-edge/zh_CN/2.4.0/releasenotes/new_feature_2.4.0.html'
            }
          ]
        }
      ]
    },
    {
      category: 'EnOS 基础',
      description: 'EnOS，全球领先的智能物联网技术底座，致力于推动企业和城市低碳数字化转型，实现生态发展。',
      image: 'assets/images/EnOS_101.png',
      url: '',
      item: [
        {
          name: 'EnOS 概述',
          description: '了解 EnOS 的优势和关键概念。',
          image: 'assets/images/common-resource_bw.png',
          list: [
            {
              name: '什么是 EnOS',
              url: '/docs/enos/zh_CN/2.4.0/overview/enos_introduction.html'
            },
            {
              name: 'EnOS 优势',
              url: '/docs/enos/zh_CN/2.4.0/overview/advantage.html'
            },
            {
              name: '常见问题',
              url: '/docs/enos/zh_CN/2.4.0/faq/index.html'
            }
          ]
        },
        {
          name: '入门信息',
          description: '了解如何访问 EnOS，应用使能以及设备连接与管理等主要能力。',
          image: 'assets/images/start.png',
          list: [
            {
              name: '访问 EnOS',
              url: '/docs/enos/zh_CN/2.4.0/get_started/accessing_enos.html'
            },
            {
              name: 'EnOS 应用使能',
              url: '/docs/enos/zh_CN/2.4.0/get_started/app.html'
            },
            {
              name: 'EnOS 设备连接与管理',
              url: '/docs/enos/zh_CN/2.4.0/get_started/device.html'
            }
          ]
        }
      ]
    },
    {
      category: '教程',
      description: '浏览 AIoT 各场景教程，快速学习 EnOS 产品使用。',
      image: 'assets/images/tutorial.png',
      url: '',
      item: [
        {
          name: '应用使能',
          description: '',
          image: 'assets/images/app_bw.png',
          list: [
            {
              name: '接入光伏场站及其气象站设备到 EnOS',
              url: '/docs/onboarding-tool/zh_CN/2.4.0/tutorial/onboarding.html'
            },
            {
              name: '创建智能电池指标页面',
              url: '/docs/dtv/zh_CN/2.4.0/tutorial/index.html'
            },
            {
              name: '创建纯水净化系统监控页面',
              url: '/docs/dtv/zh_CN/2.4.0/tutorial/monitor.html'
            },
            {
              name: '创建并关闭一个工单',
              url: '/docs/wmt/zh_CN/2.4.0/tutorial/creating_and_completing_work_order.html'
            },
            {
              name: '开发光伏发电量、温度与辐照指标',
              url: '/docs/metric-management/zh_CN/2.4.0/tutorial/index.html'
            },
            {
              name: '评估风机设备的数据质量',
              url: '/docs/data-quality/zh_CN/2.4.0/tutorial.html'
            }
          ]
        },
        {
          name: '设备连接与管理',
          description: '',
          image: 'assets/images/IoT Hub_LIght.png',
          image: 'assets/images/device_bw.png',
          list: [

            {
              name: '将模拟设备连接到 EnOS',
              url: '/docs/device-connection/zh_CN/2.4.0/tutorial/connecting_device_simulated/index.html'
            },
            {
              name: '将模拟电表通过 IEC104 规约接入到 EnOS Edge',
              url: '/docs/enos-edge/zh_CN/2.4.0/tutorial/connecting_edge.html'
            },
            {
              name: '为同一模型的设备设置不同阈值的告警',
              url: '/docs/alert/zh_CN/2.4.0/howto/set_alert_rule_for_device.html'
            },
            {
              name: '设置告警延时触发',
              url: '/docs/alert/zh_CN/2.4.0/howto/setting_alert_triggering_delay_timer.html'
            },
            {
              name: '设置根据设备状态触发的告警',
              url: '/docs/alert/zh_CN/2.4.0/howto/setting_state_based_alert.html'
            },
            {
              name: '接入树莓派即插即用',
              url: '/docs/device-provisioning/zh_CN/2.4.0/tutorials/pnp_raspberry_pi/index.html'
            },
            {
              name: '重新配置设备',
              url: '/docs/device-provisioning/zh_CN/2.4.0/tutorials/reprovisioning/index.html'
            },
            {
              name: '替换设备',
              url: '/docs/device-provisioning/zh_CN/2.4.0/tutorials/replacing_device/index.html'
            }
          ]
        },
        {
          name: '数据管理与分析',
          description: '',
          image: 'assets/images/data_bw.png',
          list: [
            {
              name: 'PC 设备数据集成',
              url: '/docs/device-integration/zh_CN/2.4.0/howto/tutorial_pc_device_mgmt.html'
            },
            {
              name: '创建主数据模型和关系模型',
              url: '/docs/data-asset-catalog/zh_CN/2.4.0/tutorials/tutorial_1.html'
            },
            {
              name: '基于标签的数据过滤和计算',
              url: '/docs/data-asset-catalog/zh_CN/2.4.0/tutorials/tutorial_2.html'
            },       
            {
              name: '开发机器学习模型预测风功率',
              url: '/docs/ai-analytics/zh_CN/2.4.0/tutorial/index.html'
            }
          ]
        }
      ]
    },
    
    {
      category: '应用使能',
      image: 'assets/images/Application_Enablement_Platform_LIght.png',
      description: '提供应用使能所需的各类工具组件和服务，帮助你快速构建、部署和扩展零代码、低代码或高阶应用。',
      image: 'assets/images/app_dev.png',
      url: '/docs/enos/zh_CN/2.4.0/get_started/app.html',
      messageTip: { 
        type: 'info',
        message: '参考信息',
        description: {
          type: 'link',
          content: [
            {
              text: '应用使能概述',
              url: '/docs/app-development/zh_CN/2.4.0/app_dev_overview.html'
            },
            {
              text: '基于行业应用组件构建应用',
              url: '/docs/app-development/zh_CN/2.4.0/app_dev_workflow/index.html'
            }
          ]
        }
      },
          item: [
        {
          name: '应用门户',
          description: '灵活的权限管理门户和统一的应用访问门户。为组织管理员提供基于角色的访问控制（RBAC）体系，并为终端用户带来流畅便捷的应用访问体验。应用门户集成 EnOS 各项服务与数据，帮助企业提高权限管理效率、降低应用研发成本。',
          image: 'assets/images/aep/Application_Portal.png',
          list: [
            {
              name: '应用门户概述',
              url: '/docs/app-portal/zh_CN/2.4.0/overview.html'
            },
            {
              name: '关键概念',
              url: '/docs/app-portal/zh_CN/2.4.0/concept.html'
            },
            {
              name: '快速入门',
              url: '/docs/app-portal/zh_CN/2.4.0/start/setting_up_app_portal.html'
            },
            {
              name: '应用门户 API',
              url: '/docs/app-portal-api/zh_CN/2.4.0/overview.html'
            }
          ]
        },
        {
          name: '通用数据服务',
          description: '基于统一数据源注册标准，向数据消费者提供标准化、一站式的数据访问途径的统一 API 服务。可访问数据包括资产信息、测点、属性、指标、记录等，同时具备基于轻量计算自定义数据的能力。',
          image: 'assets/images/aep/Common_Data_Service.png',
          list: [
            {
              name: '通用数据服务概述',
              url: '/docs/cds/zh_CN/2.4.0/overview.html'
            },
            {
              name: '初次配置通用数据服务',
              url: '/docs/cds/zh_CN/2.4.0/getstarted/setup.html'
            },
            {
              name: '通用数据服务 API',
              url: '/docs/cds-app-api/zh_CN/2.4.0/overview.html'
            }
          ]
        },
        {
          name: '接入工具',
          description: '一站式资产接入工具，助力资产管理员批量接入和管理不同类型的资产。',
          image: 'assets/images/onboarding.png',
          list: [
            {
              name: '接入工具概述',
              url: '/docs/onboarding-tool/zh_CN/2.4.0/learn/onboarding_tool_overview.html'
            },
            {
              name: '快速入门',
              url: '/docs/onboarding-tool/zh_CN/2.4.0/learn/quickstarts.html'
            },
            {
              name: '接入工具 API',
              url: '/docs/onboarding-tool-api/zh_CN/2.4.0/overview.html'
            }
          ]
        },
        {
          name: '统一监测',
          description: '拥有多样化、跨领域监控能力的一站式监测配置中心。统一监测赋能实施交付团队快速构建跨领域监测页面，并以地图、列表、图表以及报告等多种形式助力终端用户实现资产状态与指标的可视化监测。针对跨领域海量资产监测场景，企业可借助统一监测提高监控页面的开发效率并缩短项目周期。',
          image: 'assets/images/aep/monitoring.png',
          list: [
            {
              name: '统一监测概述',
              url: '/docs/monitor/zh_CN/2.4.0/overview/monitor_overview.html'
            },
            {
              name: '关键概念',
              url: '/docs/monitor/zh_CN/2.4.0/overview/key_concepts.html'
            },
            {
              name: '探索统一监测',
              url: '/docs/monitor/zh_CN/2.4.0/get_started/explore.html'
            }
          ]
        },
        {
          name: '数字孪生可视化',
          description: '数字孪生可视化是一个基于模型的低代码应用开发工具，提供丰富的组件及灵活的配置能力，赋能平民开发者快速构建可视化应用，极大提升开发效率，并结合 2D 和 3D 技术，增强监控和运营应用的用户体验。',
          image: 'assets/images/aep/Digital_Twin_Visualization.png',
          list: [
            {
              name: '数字孪生可视化概述',
              url: '/docs/dtv/zh_CN/2.4.0/overview.html'
            },
            {
              name: '管理指标工具的项目与页面',
              url: '/docs/dtv/zh_CN/2.4.0/building_dashboard/managing_project_pages.html'
            },
            {
              name: '指标工具组件',
              url: '/docs/dtv/zh_CN/2.4.0/reference/widgets/index.html'
            },
            {
              name: '使用监控工具中的图纸',
              url: '/docs/dtv/zh_CN/2.4.0/building_m&c_panel/managing_panel.html'
            }
          ]
        },
        {
          name: '告警管理',
          description: '对告警全生命周期进行管理的工具。通过告警触发规则、告警通知规则、告警响应规则的配置，及时识别设备运行中的异常情况，生成告警并对相关人员进行通知，保证异常情况得到及时、有效的处理。告警管理通过提高设备运行的稳定性，帮助企业实现经营管理中的降本、增效。',
          image: 'assets/images/alarm.png',
          list: [
            {
              name: '告警管理概述',
              url: '/docs/alarm-management/zh_CN/2.4.0/overview/about.html'
            },
            {
              name: '关键概念',
              url: '/docs/alarm-management/zh_CN/2.4.0/overview/key_concepts.html'
            },
            {
              name: '快速入门',
              url: '/docs/alarm-management/zh_CN/2.4.0/getting_started/quick_start.html'
            }
          ]
        },
        {
          name: '工作管理',
          description: '端到端的工单管理工具，覆盖网页与移动端双端，并与 EnOS 监控和高级分析应用无缝集成，实现告警闭环及日常任务管理。基于连接器简化与第三方 CMMS/EAM 的集成。',
          image: 'assets/images/workmanagement.png',
          list: [
            {
              name: '工作管理概述',
              url: '/docs/wmt/zh_CN/2.4.0/about.html'
            },
            {
              name: '新建工单',
              url: '/docs/wmt/zh_CN/2.4.0/howto/creating_work_order.html'
            },
            {
              name: '工作管理 API',
              url: '/docs/wmt-api/zh_CN/2.4.0/overview.html'
            }
          ]
        },
        {
          name: '报表工具',
          description: '基于 EnOS 的轻量报表工具，提供包括模板定义、报表生成、订阅、预览、下载在内的一站式报表制作及管理能力，助力企业和机构实现零代码制作报表和轻松管理日常报表任务。',
          image: 'assets/images/aep/Reporting_Tool.png',
          list: [
            {
              name: '报表工具概述',
              url: '/docs/reporting/zh_CN/2.4.0/overview.html'
            },
            {
              name: '关键概念',
              url: '/docs/reporting/zh_CN/2.4.0/concept.html'
            },
            {
              name: '快速入门',
              url: '/docs/reporting/zh_CN/2.4.0/getstarted/quickstart.html'
            }
          ]
        },
        {
          name: '集群控制',
          description: '面向领域应用提供开箱即用的集中控制服务，包括：基于行业标准沉淀控制能力和开放用户自定义控制面板，以适配广泛的控制场景和实现安全合规的控制操作，助力企业低成本、快捷地开发控制类应用。',
          image: 'assets/images/aep/Fleet_Control.png',
          list: [
            {
              name: '集群控制概述',
              url: '/docs/control/zh_CN/2.4.0/overview.html'
            },
            {
              name: '关键概念',
              url: '/docs/control/zh_CN/2.4.0/concept.html'
            },
            {
              name: '探索控制面板',
              url: '/docs/control/zh_CN/2.4.0/getstarted/panel_explore.html'
            }
          ]
        },  
        {
          name: '指标管理',
          description: '集指标规范化定义、指标配置化计算和指标统一查询服务于一体，帮助企业构建统一、安全、高效的指标体系平台。',
          image: 'assets/images/metric.png',
          list: [
            {
              name: '指标管理概述',
              url: '/docs/metric-management/zh_CN/2.4.0/overview/metrics_overview.html'
            },
            {
              name: '关键概念​',
              url: '/docs/metric-management/zh_CN/2.4.0/overview/metrics_concept.html'
            },
            {
              name: '管理指标​',
              url: '/docs/metric-management/zh_CN/2.4.0/howto/metric.html'
            },
            {
              name: '指标管理 API',
              url: '/docs/metric-api/zh_CN/2.4.0/overview.html'
            }
          ]
        },
        {
          name: '数据质量',
          description: '基于可配的质量规则，从完整性、有效性和及时性三个质量维度对实时数据进行质量监控，生成可视化的质量大盘及报表，帮助企业轻松评估数据质量水平。',
          image: 'assets/images/dq.png',
          list: [
            {
              name: '数据质量概述',
              url: '/docs/data-quality/zh_CN/2.4.0/overview/about.html'
            },
            {
              name: '关键概念​',
              url: '/docs/data-quality/zh_CN/2.4.0/overview/key_concept.html'
            },
            {
              name: '配置质量评估规则',
              url: '/docs/data-quality/zh_CN/2.4.0/howto/rule.html'
            },
            {
              name: '查看数据质量',
              url: '/docs/data-quality/zh_CN/2.4.0/howto/quality_dashboard.html'
            }
          ]
        },
        {
          name: 'DevOps',
          description: '基于 DevOps 最佳实践和最佳工具组合简化应用的开发、部署、运维和扩展，赋能应用开发人员和运营人员高效无缝协作，实现敏捷的业务创新。',
          image: 'assets/images/aep/Developer_Studio.png',
          list: [
            {
              name: 'DevOps 概述',
              url: '/docs/app-development/zh_CN/2.4.0/developer_studio/devops/devops.html'
            },
            {
              name: '管理流水线',
              url: '/docs/app-development/zh_CN/2.4.0/developer_studio/devops/pipeline/pipeline.html'
            },
            {
              name: '发布应用',
              url: '/docs/app-development/zh_CN/2.4.0/developer_studio/devops/publishing_app/publishing_app.html'
            }
          ]
        },
        {
          name: '应用商店',
          description: '基于 Helm Chart 陈列通用和可复用组件或服务的集合，对该类服务以模板形式进行快速部署，简化业务应用的开发。',
          image: 'assets/images/aep/Application_Hosting.png',
          list: [
            {
              name: '应用商店概述',
              url: '/docs/app-development/zh_CN/2.4.0/developer_studio/app_hub/index.html'
            },
            {
              name: '从应用商店部署应用',
              url: '/docs/app-development/zh_CN/2.4.0/developer_studio/app_hub/gettingstarted_dev_env.html'
            },
            {
              name: '管理应用模板',
              url: '/docs/app-development/zh_CN/2.4.0/developer_studio/app_hub/managing_app_template.html'
            },
            {
              name: '部署应用实例',
              url: '/docs/app-development/zh_CN/2.4.0/developer_studio/app_hub/deploying_app_instance.html'
            }
          ]
        },
        {
          name: '函数计算',
          description: '提供事件驱动的函数计算服务，以弹性、可靠的方式运行函数代码，实现函数级资源分配和调度。',
          image: 'assets/images/aep/Serverless.png',
          list: [
            {
              name: '函数计算概述',
              url: '/docs/app-development/zh_CN/2.4.0/developer_studio/functions/serverless_overview.html'
            },
            {
              name: '发布函数类型应用',
              url: '/docs/app-development/zh_CN/2.4.0/developer_studio/functions/managing_function.html'
            }
          ]
        },
        {
          name: '消息推送管理',
          description: '提供面向用户的消息推送服务，支持管理推送账户和服务配额，即时向用户推送通知短信和邮件，与用户保持互动。',
          image: 'assets/images/edp/Data_Subscription.png',
          list: [
            {
              name: '消息推送管理概述',
              url: '/docs/notification-mgmt/zh_CN/2.4.0/notification_center_overview.html'
            },
            {
              name: '快速入门',
              url: '/docs/notification-mgmt/zh_CN/2.4.0/notification_gettingstarted.html'
            },
            {
              name: '消息推送服务 API ',
              url: '/docs/notification-mgmt-api/zh_CN/2.4.0/overview.html'
            }
          ]
        },
        {
          name: 'API 管理',
          description: '提供安全的 API 全生命周期管理，帮助企业快速通过 API 实现业务增长和开放集成。',
          image: 'assets/images/aep/API_Management.png',
          list: [
            {
              name: 'API 管理概述',
              url: '/docs/apim/zh_CN/2.4.0/api_management_overview.html'
            },
            {
              name: 'API 生命周期管理',
              url: '/docs/apim/zh_CN/2.4.0/api_lifecycle_management.html'
            },
            {
              name: 'API 管理安全机制',
              url: '/docs/apim/zh_CN/2.4.0/apim_security.html'
            },
            {
              name: '快速入门',
              url: '/docs/apim/zh_CN/2.4.0/learn/api_management_quickstart.html'
            }
          ]
        },
        {
          name: 'EnOS API',
          description: '提供涵盖 EnOS 各个核心业务流程的 API 接口和 API 文档，帮助快速访问系统资源，加速应用开发。',
          image: '',
          list: [
            {
              name: 'EnOS API 概述',
              url: '/docs/api/zh_CN/2.4.0/overview.html'
            },
            {
              name: 'API 鉴权',
              url: '/docs/api/zh_CN/2.4.0/authen_overview.html'
            },
            {
              name: 'EnOS API 快速入门',
              url: '/docs/api/zh_CN/2.4.0/gettingstarted.html'
            }
          ]
        }
      ]
    },
    {
      category: '设备连接与管理',
      description: '广泛、安全和快速的连接到多源异构的传感器、设备及系统，提供设备的全生命周期管理。',
      image: 'assets/images/device.png',
      item: [
        {
          name: '设备连接与管理服务',
          description: '支持海量异构设备或系统的实时和历史数据的快速接入和管理；内置数字孪生模型库，快速实现行业领域设备的数字化抽象；提供设备的全生命周期管理和动态告警触发，实现设备异常及故障的快速响应。',
          image: 'assets/images/iothub/Connectivity.png',
          list: [
            {
              name: '设备连接与管理概述',
              url: '/docs/device-connection/zh_CN/2.4.0/device_management_overview.html'
            },
            {
              name: '模型管理',
              url: '/docs/device-connection/zh_CN/2.4.0/howto/model/index.html'
            },
            {
              name: '设备连接与管理 API',
              url: '/docs/device-connection/zh_CN/2.4.0/reference/api_reference'
            }
          ]
        },
        {
          name: '告警引擎',
          description: '为运行和维护团队提供告警引擎的服务，通过定义、接收和处理组织资产的告警，及早发现异常情况并迅速做出反应主动通知用户，满足对资产的实时状态监控和故障分析等业务需求。',
          image: 'assets/images/Alert.png',
          list: [
            {
              name: '告警引擎概述',
              url: '/docs/alert/zh_CN/2.4.0/learn/alert_overview.html'
            },
            {
              name: '快速入门',
              url: '/docs/alert/zh_CN/2.4.0/howto/gettingstarted.html'
            },
            {
              name: '告警引擎 API',
              url: '/docs/alert-api/zh_CN/2.4.0/overview.html'
            }
          ]
        },
        {
          name: '设备预配置',
          description: '一项有助于简化和实现数百万物联网设备零接触接入的服务，通过简单和快速的配置，实现设备的可扩展和安全配置。',
          image: 'assets/images/dps.png',
          list: [
            {
              name: '设备预配置概述',
              url: '/docs/device-provisioning/zh_CN/2.4.0/overview/about.html'
            },
            {
              name: '快速入门',
              url: '/docs/device-provisioning/zh_CN/2.4.0/getting_started/device_provisioning.html'
            },
            {
              name: '设备预配置 API',
              url: '/docs/dps-api/zh_CN/2.4.0/overview.html'
            }
          ]
        },
        {
          name: 'EnOS Edge',
          description: 'EnOS Edge 通过内置协议库适配并加速设备连接，提供边缘计算和本地控制，帮助用户及时决策和响应，将云端智能扩展至边缘。',
          image: 'assets/images/edge/user.png',
          list: [
            {
              name: 'EnOS Edge 概述',
              url: '/docs/enos-edge/zh_CN/2.4.0/edge_overview.html'
            },
            {
              name: '开发指南',
              url: '/docs/enos-edge/zh_CN/2.4.0/howto/developer_guide/app_dev_overview.html'
            },
            {
              name: 'EnOS Edge API',
              url: '/docs/edge-api/zh_CN/2.4.0/index.html'
            }
          ]
        }
      ]
    },
    {
      category: '数据管理与分析',
      image: 'assets/images/data.png',
      description: '挖掘数据资产价值，降低海量物联网数据的 TCO，帮助你实现对设备资产数据的高效管理。',
      item: [
        {
          name: '设备数据集成服务',
          description: '通过拖拉拽体验的低代码任务流方式加速企业设备数据集成, 并提供运行状态监控与告警服务，降低运维成本。',
          image: 'assets/images/iothub/Integration.png',
          list: [
            {
              name: '设备数据集成服务概述',
              url: '/docs/device-integration/zh_CN/2.4.0/learn/device_integration_overview.html'
            },
            {
              name: '快速入门',
              url: '/docs/device-integration/zh_CN/2.4.0/howto/gettingstarted_storing_data'
            },
            {
              name: '节点参考',
              url: '/docs/device-integration/zh_CN/2.4.0/reference/index_nodes.html'
            }
          ]
        },
        {
          name: '数据源注册',
          description: '支持 EnOS 内外部数据源统一注册及管理，以供相关产品模块直接访问数据源信息。',
          image: 'assets/images/datasourceregistration.png',
          list: [
            {
              name: '数据源注册概述',
              url: '/docs/data-source-reg/zh_CN/2.4.0/datasource_overview.html'
            },
            {
              name: '注册 MySQL 或 SQL Server 数据源',
              url: '/docs/data-source-reg/zh_CN/2.4.0/connecting_mysql.html'
            }
          ]
        },
        {
          name: '数据同步',
          description: '打通外部存储系统与 EnOS 内部存储系统之间的数据传输通道，帮助实现集中式数据同步和共享。',
          image: 'assets/images/edp/Data_Synchronization.png',
          list: [
            {
              name: '数据同步概述',
              url: '/docs/data-sync/zh_CN/2.4.0/di_overview.html'
            },
            {
              name: '创建从外部数据库同步数据到 Hive 库的手动调度的任务',
              url: '/docs/data-sync/zh_CN/2.4.0/creating_scratch_onetime.html'
            },
            {
              name: '从 EnOS Hive 同步数据到目的数据库',
              url: '/docs/data-sync/zh_CN/2.4.0/creating_scratch_hive2mysql.html'
            }
          ]
        },   
        {
          name: '数据联邦',
          description: '在不移动或同步数据的情况下，为企业的多源异构数据存储系统建立统一的数据读写服务，赋能不同的数据使用方能够通过标准 SQL、JDBC、或 OData 等统一查询方式高效访问数据。',
          image: 'assets/images/edp/Data_Federation.png',
          list: [
            {
              name: '数据联邦概述',
              url: '/docs/data-federation/zh_CN/2.4.0/data_federation_overview.html'
            },
            {
              name: '通道管理',
              url: '/docs/data-federation/zh_CN/2.4.0/channel_management.html'
            },
            {
              name: '读写数据',
              url: '/docs/data-federation/zh_CN/2.4.0/data_rw.html'
            },
            {
              name: '数据联邦 API',
              url: '/docs/data-federation-api/zh_CN/2.4.0/overview.html'
            }
          ]
        },
        {
          name: '流数据处理',
          description: '沉淀典型计算场景的通用算子及模板，支持数据开发者拖拽式无代码快速开发流数据处理与分析的任务流。',
          image: 'assets/images/edp/Stream_Processing.png',
          list: [
            {
              name: '流数据处理概述',
              url: '/docs/stream-processing/zh_CN/2.4.0/streaming_overview.html'
            },
            {
              name: '使用算法模板开发流数据处理任务',
              url: '/docs/stream-processing/zh_CN/2.4.0/dev.html'
            },
            {
              name: '运维流数据处理任务',
              url: '/docs/stream-processing/zh_CN/2.4.0/ops.html'
            },
            {
              name: '流数据处理 API',
              url: '/docs/stream-processing-api/zh_CN/2.4.0/overview.html'
            }
          ]
        },
        {
          name: '批数据处理',
          description: '帮助数据开发者通过可视化任务流的方式进行大规模数据处理，提供稳定的调度服务，并可基于数据湖、数据仓库及用户侧应用，对相关数据进行计算、分析、洞察等。',
          image: 'assets/images/edp/Batch_Processing.png',
          list: [
            {
              name: '批数据处理概述​',
              url: '/docs/batch-processing/zh_CN/2.4.0/dataide_overview.html'
            },
            {
              name: '任务资源管理',
              url: '/docs/batch-processing/zh_CN/2.4.0/job_resource/index.html'
            },
            {
              name: '任务流开发',
              url: '/docs/batch-processing/zh_CN/2.4.0/data_dev/index.html'
            },
            {
              name: '任务运维',
              url: '/docs/batch-processing/zh_CN/2.4.0/task_monitor/index.html'
            }
          ]
        },
        {
          name: '时序数据管理',
          description: '为海量物联网时序数据提供高吞吐、高可用、高压缩比的存储，并配套提供高效查询 API 及可视化工具，实现对时序数据的快速洞察。',
          image: 'assets/images/edp/Time_Series_Data_Management.png',
          list: [
            {
              name: '时序数据管理概述',
              url: '/docs/time-series-data/zh_CN/2.4.0/overview.html'
            },
            {
              name: '入门指引：数据存储配置和读取',
              url: '/docs/time-series-data/zh_CN/2.4.0/getting_started.html'
            },
            {
              name: '存储策略（EnOS Cloud 用户）',
              url: '/docs/time-series-data/zh_CN/2.4.0/cloudpolicy/policy.html'
            },
            {
              name: '存储策略（EnOS Edge 用户）',
              url: '/docs/time-series-data/zh_CN/2.4.0/edgepolicy/policy.html'
            },
            {
              name: '时序数据管理 API',
              url: '/docs/time-series-data/zh_CN/2.4.0/reference/api.html'
            }
          ]
        },
        {
          name: '数据订阅',
          description: '数据订阅服务支持将订阅的数据实时推送给消费数据的应用，提高应用获取和消费资产数据的效率。基于数据订阅服务提供的 SDK，应用可高效地进行数据订阅。',
          image: 'assets/images/edp/Data_Subscription.png',
          list: [
            {
              name: '数据订阅概述​',
              url: '/docs/data-subscription/zh_CN/2.4.0/data_subscription_overview.html'
            },
            {
              name: '入门指引：订阅时序数据',
              url: '/docs/data-subscription/zh_CN/2.4.0/gettingstarted_subscribe_realtime.html'
            },
            {
              name: '入门指引：订阅基础告警数据',
              url: '/docs/data-subscription/zh_CN/2.4.0/gettingstarted_subscribe_alerts.html'
            },
            {
              name: '消费订阅数据（EnOS Cloud 用户）',
              url: '/docs/data-subscription/zh_CN/2.4.0/consuming_subscribed_data.html'
            },
            {
              name: '消费订阅数据（EnOS Edge 用户）',
              url: '/docs/data-subscription/zh_CN/2.4.0/consuming_subscribed_data_edge.html'
            },
            {
              name: '数据订阅 SDK 参考',
              url: '/docs/data-subscription/zh_CN/2.4.0/data_subscription_sdk.html'
            }
          ]
        },
        {
          name: '数据归档',
          description: '通过周期性归档任务实现大规模数据备份，对访问频率较低且占用存储空间大的“冷数据”进行经济化存储。',
          image: 'assets/images/edp/Data_Archiving.png',
          list: [
            {
              name: '数据归档概述',
              url: '/docs/data-archiving/zh_CN/2.4.0/archive_policy.html'
            },
            {
              name: '配置数据归档任务',
              url: '/docs/data-archiving/zh_CN/2.4.0/configuring_archive_storage.html'
            },
            {
              name: '数据归档参考说明',
              url: '/docs/data-archiving/zh_CN/2.4.0/archive_storage.html'
            }
          ]
        },
        {
          name: '数据资产目录',
          description: '助力管理多源数据、高效检索、血缘追踪等全面的数据治理活动，帮助快速理解企业数据资产，实现数据资产的集中式管理及分析。',
          image: 'assets/images/edp/Data_Asset_Catalog.png',
          list: [
            {
              name: '数据资产目录概述',
              url: '/docs/data-asset-catalog/zh_CN/2.4.0/data_catalog_intro.html'
            },
            {
              name: '关键概念',
              url: '/docs/data-asset-catalog/zh_CN/2.4.0/data_catalog_concept.html'
            },
            {
              name: '快速入门',
              url: '/docs/data-asset-catalog/zh_CN/2.4.0/data_catalog_quickstart.html'
            },
            {
              name: '数据资产目录 API',
              url: '/docs/data-catalog-api/zh_CN/2.4.0/overview.html'
            }
          ]
        }, 
        {
          name: '数据集管理',
          description: '通过创建可用于算法开发和模型训练的数据集，帮助数据科学家在训练模型时快速访问数据，而不用关心如何连接数据源以及不同数据源的连接串和数据访问路径的差异，提升工作效率。',
          image: 'assets/images/eap/Dataset_Management.png',
          list: [
            {
              name: '数据集管理概述',
              url: '/docs/ai-analytics/zh_CN/2.4.0/dataset_management/dataset_overview.html'
            },
            {
              name: '创建数据集',
              url: '/docs/ai-analytics/zh_CN/2.4.0/dataset_management/creating_dataset.html'
            },
            {
              name: '管理数据集',
              url: '/docs/ai-analytics/zh_CN/2.4.0/dataset_management/managing_dataset.html'
            },
            {
              name: '探索分析数据集',
              url: '/docs/ai-analytics/zh_CN/2.4.0/dataset_management/exploring_dataset.html'
            }
          ]
        },
        {
          name: '智能实验室',
          description: '集成主流的 JupyterLab 和 MLflow 作为模型开发环境，支持多样化格式打包机器学习模型，赋能模型的可视化对比与选优、实例的按需申请与协作共享，缩短复杂模型的训练周期。',
          image: 'assets/images/eap/MI_Lab.png',
          list: [
            {
              name: '智能实验室概述',
              url: '/docs/ai-analytics/zh_CN/2.4.0/mi_lab/mi_lab_overview.html'
            },
            {
              name: '管理 Notebook 实例',
              url: '/docs/ai-analytics/zh_CN/2.4.0/mi_lab/managing_notebook.html'
            },
            {
              name: '管理模型代码',
              url: '/docs/ai-analytics/zh_CN/2.4.0/mi_lab/integrating_with_git.html'
            },
            {
              name: '监控 Notebook 运行实例',
              url: '/docs/ai-analytics/zh_CN/2.4.0/mi_lab/integrating_with_mlflow.html'
            }
          ]
        },
        {
          name: '智能集市',
          description: '作为 AI 资产的集散中心，为模型开发者提供全面 AI 资产注册、托管与版本管理服务，高效管理 AI 资产，全面提升模型工程化效率。',
          image: 'assets/images/eap/MI_Hub.png',
          list: [
            {
              name: '智能集市概述',
              url: '/docs/ai-analytics/zh_CN/2.4.0/mi_hub/mi_hub_overview.html'
            },
            {
              name: '注册模型',
              url: '/docs/ai-analytics/zh_CN/2.4.0/mi_hub/registering_model.html'
            },
            {
              name: '部署上线模型版本',
              url: '/docs/ai-analytics/zh_CN/2.4.0/mi_hub/version_deployment.html'
            },
            {
              name: '监控模型生产指标',
              url: '/docs/ai-analytics/zh_CN/2.4.0/mi_hub/monitoring_indicator.html'
            }
          ]
        },
        {
          name: '智能任务流',
          description: '通过编排任务流实现机器学习算法模型的自动化上线部署及运行监控等端到端的生命周期管理，可灵活根据业务逻辑编排各类机器学习的任务节点，实现机器学习全链路闭环与持续的集成和部署。',
          image: 'assets/images/eap/MI_Pipelines.png',
          list: [
            {
              name: '智能任务流概述',
              url: '/docs/ai-analytics/zh_CN/2.4.0/mi_pipelines/mi_pipeline_overview.html'
            },
            {
              name: '管理作业流',
              url: '/docs/ai-analytics/zh_CN/2.4.0/mi_pipelines/creating_workflow.html'
            },
            {
              name: '设计开发任务流',
              url: '/docs/ai-analytics/zh_CN/2.4.0/mi_pipelines/developing_model.html'
            },
            {
              name: '算子参考文档',
              url: '/docs/ai-analytics/zh_CN/2.4.0/mi_pipelines/calculator.html'
            }
          ]
        },
        {
          name: '资源配置',
          description: '提供统一的计算资源、存储资源配置和数据源连接管理功能，为智能工作室中的智能实验室、智能集市、智能任务流等服务提供基础的连接及资源配备，帮助快速按需配置资源以开展机器学习相关工作。',
          image: 'assets/images/eap/Resource_Configuration.png',
          list: [
            {
              name: '资源配置概述',
              url: '/docs/ai-analytics/zh_CN/2.4.0/resource_configuration/resource_configuration_overview.html'
            },
            {
              name: '管理动态存储',
              url: '/docs/ai-analytics/zh_CN/2.4.0/resource_configuration/managing_storage.html'
            },
            {
              name: '配置数据源连接',
              url: '/docs/ai-analytics/zh_CN/2.4.0/resource_configuration/configuring_connection.html'
            }
          ]
        }       
      ]
    },
    {
      category: 'EnOS 管理',
      description: 'EnOS，全球领先的智能物联网操作系统，致力于推动企业和城市数字化转型，实现生态发展。 ',
      image: 'assets/images/EnOS_admin.png',
      url: '',
      item: [
        {
          name: '身份与授权',
          description: '提供用户帐号生命周期管理，支持对EnOS资源的访问权限控制，实现对用户身份与权限的集中化、灵活化管理，有效保护企业信息安全。',
          image: 'assets/images/iam.png',
          list: [
            {
              name: '身份与授权概述',
              url: '/docs/enos/zh_CN/2.4.0/iam/iam_overview.html'
            },
            {
              name: '关键概念',
              url: '/docs/enos/zh_CN/2.4.0/iam/concept/index.html'
            },
            {
              name: 'LDAP 联合',
              url: '/docs/enos/zh_CN/2.4.0/iam/ou_admin/ldap/index.html'
            }
          ]
        },
        {
          name: '单点登录服务',
          description: '基于主流的标准协议，实现 EnOS 与第三方应用的单点登录，解决同一公司跨业务应用间的身份认证问题。',
          image: 'assets/images/aep/Single_Sign-On_Service.png',
          list: [
            {
              name: '单点登录概述',
              url: '/docs/sso/zh_CN/2.4.0/sso_overview.html'
            },
            {
              name: '关键概念',
              url: '/docs/sso/zh_CN/2.4.0/sso_concept.html'
            }
          ]
        },
        {
          name: '资源管理',
          description: '支持对资源使用的灵活管理，可对资源利用进行告警设置，提高企业资源透明度与资源利用率，减少资源成本浪费。',
          image: 'assets/images/resource.png',
          list: [
            {
              name: 'EnOS 上的资源',
              url: '/docs/enos/zh_CN/2.4.0/resourcemanagement/overview.html'
            },
            {
              name: '资源规格说明',
              url: '/docs/enos/zh_CN/2.4.0/resourcemanagement/reference/index.html'
            },
            {
              name: '资源管理操作',
              url: '/docs/enos/zh_CN/2.4.0/resourcemanagement/getstarted.html'
            }
          ]
        },
        {
          name: '计量',
          description: '多维度展示接入平台资源和服务使用的计量数据, 平台运营人员可通过各项计量统计数据评估平台运营情况，为运营策略调整提供数据支撑。',
          image: 'assets/images/metering.png',
          list: [
            {
              name: '计量服务概述',
              url: '/docs/enos/zh_CN/2.4.0/metering/metering_overview.html'
            },
            {
              name: '关键概念',
              url: '/docs/enos/zh_CN/2.4.0/metering/metering_concepts.html'
            }
          ]
        },
        {
          name: '审计服务',
          description: '支持对用户的登录登出和各项操作行为进行监控和审计，操作历史事件在保存期内可保证所有记录的不可篡改性和可追溯性，满足企业客户的安全合规要求。',
          image: 'assets/images/audit.png',
          list: [
            {
              name: '审计服务概述',
              url: '/docs/enos/zh_CN/2.4.0/audit/audit_overview.html'
            },
            {
              name: '快速入门',
              url: '/docs/enos/zh_CN/2.4.0/audit/audit_gettingstarted.html'
            }
          ]
        },
        {
          name: '安全',
          description: '了解 EnOS 中内置的安全技术。',
          image: 'assets/images/security_bw.png',
          list: [
            {
              name: '安全概述',
              url: '/docs/enos/zh_CN/2.4.0/security/security_overview.html'
            },
            {
              name: 'X.509 证书服务',
              url: '/docs/enos/zh_CN/2.4.0/security/x509_ca/index.html'
            },
            {
              name: '安全方案',
              url: '/docs/enos/zh_CN/2.4.0/security/security_mechanisms.html'
            }
          ]
        }
      ]
    },
    {
      category: 'EnOS 运维',
      image: 'assets/images/OM.png',
      description: '一站式 EnOS 运维。',
      item: [
        {
          name: '企业运维中心',
          description: '企业运维中心针对 IaaS/PaaS/SaaS 层提供立体式全覆盖的运维监控体系的服务，帮助保障整体环境稳定性，降低企业运维成本，提升运维工作效率。',
          image: 'assets/images/eoc.png',
          list: [
            {
              name: '企业运维中心概述',
              url: '/docs/eoc/zh_CN/2.4.0/about/overview.html'
            },
            {
              name: '关键概念',
              url: '/docs/eoc/zh_CN/2.4.0/about/concept.html'
            },
            {
              name: '应用场景',
              url: '/docs/eoc/zh_CN/2.4.0/about/use_scenario.html'
            }
          ]
        }
      ]
    }
  ]
};
